export default function getRootDomain() {
  return process.env.NEXT_PUBLIC_ROOT_DOMAIN || 'localhost:3000';
}
